/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Title } from '@angular/platform-browser';
import { TemplateService } from '../../../core/template/template.service';
import { ConfigService } from '../../../core/service/config.service';

interface SnowFlakeConfig {
    depth: number;
    left: number;
    speed: number;
}

@Component({
    selector: 'marketplace',
    templateUrl: './marketplace.component.html',
    styleUrls: ['./marketplace.component.scss']
})
export class MarketPlaceComponent implements OnInit, OnDestroy {

    public vendorPrefixId = '';
    public id;
    public dialogRef: any;
    public subscriptions = [];

    public effect = '';

    public flagImage = '';

    public snowFlakes: SnowFlakeConfig[];

    public rainFall: SnowFlakeConfig[];

    constructor(public router: Router, public route: ActivatedRoute,
        private configService: ConfigService,
        private titleService: Title, private templateService: TemplateService) {
    }

    ngOnInit() {
        this.titleService.setTitle('Marketplace');
        this.subscriptions.push(this.route.params.subscribe((params) => {
            if (params && params.vendorPrefixId) {
                this.vendorPrefixId = params.vendorPrefixId;
            }
        }));

        this.subscriptions.push(this.route.params.subscribe((queryParams) => {
            if (queryParams.id) {
                this.id = queryParams.id;
                this.templateService.getTemplateSetting({ countryId: this.id }).toPromise().then((response: any) => {
                    setTimeout(() => {
                        this.effect = response.data.settings.effect;
                        this.flagImage = this.configService.getImageUrl() + `?name=${response.marketplace.flagImage}&path=${response.marketplace.flagImagePath}&width=1440`;
                    })
                })
            }
        }));

        this.snowFlakes = [];

        this.rainFall = [];

        for (var i = 1; i <= 150; i++) {

            this.snowFlakes.push({
                depth: this.randRange(1, 5),
                left: this.randRange(0, 100),
                speed: this.randRange(1, 5)
            });

            this.rainFall.push({
                depth: this.randRange(1, 5),
                left: this.randRange(0, 100),
                speed: this.randRange(1, 5)
            });


        }


    }

    private randRange(min: number, max: number): number {
        var range = (max - min);
        return (min + Math.round(Math.random() * range));
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(item => {
            item.unsubscribe();
        })
    }

    // calls listSandbox getPageDetail for detail page

}
